import { render } from "./LotteryUpdate.vue?vue&type=template&id=0b1901cc&scoped=true"
import script from "./LotteryUpdate.vue?vue&type=script&lang=js"
export * from "./LotteryUpdate.vue?vue&type=script&lang=js"

import "./LotteryUpdate.vue?vue&type=style&index=0&id=0b1901cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b1901cc"]])

export default __exports__